import {
    Grid,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAssetMaterialsLifespan } from "legacyNext/hooks";

import { S } from "./materials-lifespan.styles";

type Props = {
    assetExternalId: string;
};

export const MaterialsLifespanView = (props: Props) => {
    const { assetExternalId } = props;

    const { t } = useTranslation();

    const { data, loading } = useAssetMaterialsLifespan(assetExternalId);

    if (loading) {
        return <Skeleton variant="rectangular" width="100%" height={250} />;
    }

    return (
        <S.View>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h5" fontWeight="bold">
                                {t(
                                    "legacyNext.yearOfExtension",
                                    "year of extension"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2">
                                {data?.renovationYear
                                    ? data?.renovationYear
                                    : "-"}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h5" fontWeight="bold">
                                {t(
                                    "legacyNext.outerWallMaterial",
                                    "outer wall material"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Grid container direction="column" spacing={1}>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.materialType",
                                                "material type"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.yearOfEstablishment",
                                                "year of establishment"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.componentLifetime",
                                                "component lifetime"
                                            )}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography>
                                            {data?.outerWallMaterial}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>
                                            {data?.outerWallMaterialLifetime}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h5" fontWeight="bold">
                                {t(
                                    "legacyNext.roofCoveringMaterial",
                                    "roof covering material"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Grid container direction="column" spacing={1}>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.materialType",
                                                "material type"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.yearOfEstablishment",
                                                "year of establishment"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.componentLifetime",
                                                "component lifetime"
                                            )}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography>
                                            {data?.roofCoverMaterial}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h5" fontWeight="bold">
                                {t(
                                    "legacyNext.roofCoveringMaterial",
                                    "roof covering material"
                                )}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Grid container direction="column" spacing={1}>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.materialType",
                                                "material type"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.yearOfEstablishment",
                                                "year of establishment"
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography
                                            fontWeight="bold"
                                            variant="body2"
                                        >
                                            {t(
                                                "legacyNext.componentLifetime",
                                                "component lifetime"
                                            )}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item container spacing={2}>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>-</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </S.View>
    );
};
